<template>

    <div class="decade-component">

        <div class="inputs-container">

            <div class="input">
                <p class="text-lg text-center block mb-2">
                    Écris ci-dessous l’âge que tu avais dans ce souvenir (même approximatif) :
                </p>

                <ion-input v-model="age" @ionChange="(e) => onChange('age', e)" class="input-custom bg-grey max-w-60 mx-auto my-5" maxlength="3" type="number"></ion-input>

                <p class="text-lg text-center block mb-2">
                    <b>OU</b> la décennie dans laquelle tu étais :
                </p>

                <ion-select v-model="decade"  @ionChange="(e) => onChange('decade', e)" interface="action-sheet" class="bg-primary rounded-lg" placeholder="Clique et choisis une décennie :" cancel-text="Annuler">
                    <ion-select-option value="0-10">0 - 10 ans</ion-select-option>
                    <ion-select-option value="10-20">10 - 20 ans</ion-select-option>
                    <ion-select-option value="20-20">20 - 30 ans</ion-select-option>
                    <ion-select-option value="30-40">30 - 40 ans</ion-select-option>
                    <ion-select-option value="40-50">40 - 50 ans</ion-select-option>
                    <ion-select-option value="50-60">50 - 60 ans</ion-select-option>
                    <ion-select-option value="60-70">60 - 70 ans</ion-select-option>
                    <ion-select-option value="70-80">70 - 80 ans</ion-select-option>
                    <ion-select-option value="80-90">80 - 90 ans</ion-select-option>
                    <ion-select-option value="90-100">90 - 100 ans</ion-select-option>
                    <ion-select-option value="100-110">100 - 110 ans</ion-select-option>
                    <ion-select-option value="+110">110+ ans</ion-select-option>
                </ion-select>

            </div>

        </div>


        <div v-if="mode !== 'modify'" class="buttons">
            <button-custom strong shape="round" size="md" color="primary" border @click="confirmCompleted">{{
                    "J'ai terminé"
                                                                                                           }}
            </button-custom>
        </div>
    </div>

</template>
<script>
import { IonInput, IonSelect, IonSelectOption } from '@ionic/vue';
import ButtonCustom from "@/components/ButtonCustom";

import openToast from "@/services/ToastService";
import { showFirstError } from "@/services/FormatService";

export default {
    name: "DecadeComponent",
    components: {
        ButtonCustom,
        IonInput,
        IonSelect,
        IonSelectOption
    },
    props: {
        activity: Object,
        mode: String,
        callback: Function
    },
    data() {
        return {
            age: null,
            decade: null,
        }
    },
    mounted() {
        this.age = null;
        this.decade = null;
        if (this.activity.decade_gap) this.decade = this.activity.decade_gap;
        else if (this.activity.decade) this.age = this.activity.decade;
    },
    computed: {},
    methods: {

        saveData: function () {

            let params = {
                decade: this.age,
                decade_gap: this.decade,
            };

            switch (this.decade) {
                case '0-10':
                    params.decade = 5;
                    break;
                case '10-20':
                    params.decade = 15;
                    break;
                case '20-30':
                    params.decade = 25;
                    break;
                case '30-40':
                    params.decade = 35;
                    break;
                case '40-50':
                    params.decade = 45;
                    break;
                case '50-60':
                    params.decade = 55;
                    break;
                case '60-70':
                    params.decade = 65;
                    break;
                case '70-80':
                    params.decade = 75;
                    break;
                case '80-90':
                    params.decade = 85;
                    break;
                case '90-100':
                    params.decade = 95;
                    break;
                case '100-110':
                    params.decade = 105;
                    break;
                case '+110':
                    params.decade = 110;
            }

            this.axios.post('house/' + this.$route.params.house + '/activity/' + this.$route.params.activity + '/decade', params)
                .then((response) => {
                    this.$store.commit('setActivity', response.data);
                })
                .catch((error) => {
                    openToast(showFirstError(error?.response?.data?.errors))
                });
        },
        confirmCompleted: function () {
            if (!this.age && !this.decade) {
                openToast("Veuillez renseigner l'âge ou la décennie concernée");
                return;
            }

            this.saveData();
            this.$emit('completed');
        },

        onChange: function(input, event) {
            if (this.mode === 'modify' && event.detail.value != null && event.detail.value !== '' && event.detail.value !== '0' ) {
                if (input === 'age') {
                    this.decade = null;
                }
                else if (input === 'decade') {
                    this.age = null;
                }
                this.$store.commit('setActivity', { decade: this.age, decade_gap: this.decade });
            }
        }

    }
}
</script>

<style lang="scss" scoped>

.decade-component {

    @apply w-full flex-1;

    .inputs-container {
        max-width: 70%;
        @apply mx-auto mt-12 mb-24;


        .input {
            @apply relative px-12 pt-3 pb-10 rounded-2xl shadow-2xl bg-white text-center mb-10;
        }

        ion-select {
            --padding-bottom: 16px;
            --padding-top: 16px;
            --padding-end: 32px;
            --padding-start: 32px;
            --placeholder-color: #FFF;
            --placeholder-opacity: 1;
            &::part(text) {
                @apply text-white text-xl;
            }
            &::part(placeholder) {
                @apply text-white text-lg;
            }
            &::part(icon) {
                @apply text-white opacity-100;
            }
        }
    }

    .buttons {
        @apply text-center space-x-24 fixed bottom-4 left-0 right-0 z-10;
    }
}

</style>
